import React, { useEffect } from 'react';
import { Box, Typography, Fade } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const MaskSaveSuccess = ({ show }) => {
  useEffect(() => {
    if (show) {
      const element = document.querySelector('.mask-success-message');
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center'
        });
      }
    }
  }, [show]);

  return (
    <Fade in={show}>
      <Box
        className="mask-success-message"
        sx={{
          position: 'fixed',
          bottom: '24px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 99999,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
          padding: '2rem',
          borderRadius: '20px',
          backgroundColor: theme => theme.palette.mode === 'dark' 
            ? 'rgba(138, 43, 226, 0.15)'
            : 'rgba(255, 255, 255, 0.95)',
          boxShadow: theme => `0 8px 32px ${theme.palette.primary.main}50`,
          backdropFilter: 'blur(12px)',
          border: theme => `2px solid ${theme.palette.primary.main}50`,
          animation: 'popIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            borderRadius: 'inherit',
            background: theme => `
              radial-gradient(circle at center, ${theme.palette.primary.main}15 0%, transparent 70%),
              repeating-linear-gradient(45deg, ${theme.palette.primary.main}08 0px, ${theme.palette.primary.main}08 1px, transparent 1px, transparent 10px),
              repeating-linear-gradient(-45deg, ${theme.palette.primary.main}08 0px, ${theme.palette.primary.main}08 1px, transparent 1px, transparent 10px)
            `,
            backgroundSize: '100% 100%, 20px 20px, 20px 20px',
            opacity: 0.5,
            zIndex: -1,
          },
          '@keyframes popIn': {
            '0%': {
              transform: 'translateX(-50%) scale(0.8)',
              opacity: 0,
              marginTop: '-20px'
            },
            '50%': {
              transform: 'translateX(-50%) scale(1.1)',
              marginTop: '0px'
            },
            '100%': {
              transform: 'translateX(-50%) scale(1)',
              opacity: 1,
              marginTop: '0px'
            },
          },
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: '4rem',
            color: 'primary.main',
            animation: 'pulse 1.2s ease-in-out infinite',
            filter: theme => `drop-shadow(0 0 15px ${theme.palette.primary.main}70)`,
            '@keyframes pulse': {
              '0%': { 
                transform: 'scale(0.95)', 
                opacity: 0.7,
                filter: theme => `drop-shadow(0 0 10px ${theme.palette.primary.main}50)`
              },
              '50%': { 
                transform: 'scale(1.05)', 
                opacity: 1,
                filter: theme => `drop-shadow(0 0 25px ${theme.palette.primary.main}90)`
              },
              '100%': { 
                transform: 'scale(0.95)', 
                opacity: 0.7,
                filter: theme => `drop-shadow(0 0 10px ${theme.palette.primary.main}50)`
              },
            },
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: theme => theme.palette.mode === 'dark' ? 'white' : 'text.primary',
            textAlign: 'center',
            fontWeight: 600,
            background: theme => `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            animation: 'slideUp 0.5s ease-out 0.2s both',
            '@keyframes slideUp': {
              '0%': { 
                transform: 'translateY(20px)', 
                opacity: 0,
                filter: 'blur(4px)'
              },
              '100%': { 
                transform: 'translateY(0)', 
                opacity: 1,
                filter: 'blur(0)'
              },
            },
          }}
        >
          Maske Başarıyla Kaydedildi!
        </Typography>
      </Box>
    </Fade>
  );
};

export default MaskSaveSuccess;
